<template>
  <div></div>
</template> 

<script>
import filter_rq from './filter_rq';
import {parse_filters} from '@/functions/general.js';

export default {
  props:{
    is_intersecting:{default:false},
    m_search:{default:''},
    main_rq_name:{default:''},
    items:{default:()=>[]},//la lista que se empesara a acumalar de registros a medida q se baje en la lista pagina
  },
  mixins:[filter_rq],
  data(){
    return {
      rq_name:'',
      has_next_page:false,
      count:0,
      model:null,
      page:1,
      getting:false,
    }
  },
  computed: {
    rq_sts() { return this.$store.getters.requestStatus },
    main_rq_st(){ return this.rq_sts.find(r => r.name === this.main_rq_name) },
    main_rq_st_filter() {
      if (!this.main_rq_st) return null;
      if(this.main_rq_st.filter === undefined) {
        console.error('no se definieron filtro en config.js');
        this.main_rq_st.filter = {};
      }
      return this.main_rq_st.filter;
    },
    main_rq_st_rq(){ 
      return this.main_rq_st.rq },
  },
  watch: {
    'main_rq_st_rq'(){
      if (this.main_rq_st_rq) {
        this.main_rq_st_rq
          .then(r=>{
            this.page = 1;
            this.has_next_page = !!r.next;
            return r;
          })
      }
    },
    'm_search'(o,v){//reset
      if(o!=v){
        this.page = 1;
        this.has_next_page = false;
      }
    },
    'is_intersecting'(o,v){
      if(this.is_intersecting) this.infiniteScroll();
    }
  },
  methods: {
    infiniteScroll() {
      if(this.m_search && this.has_next_page && !this.getting) {
        this.getting = true;
        this.resetRqStatus();
        this.page++;

        const filters = parse_filters(Object.assign({},this.main_rq_st_filter,{...this.ex_filters}));
        filters.page = this.page;
        this.getRows(filters)
          .then(r => {
            this.has_next_page = !!r.next;
            if (this.has_next_page === false) this.page--;
            this.count = r.count;
            if (r.results.length) this.$emit('update:items', this.items.concat(r.results));
            this.getting = false;
            //Array.prototype.push.apply(this.items, r.results);
            //this.$emit('update:items', this.items);
          })
          .catch(e=>{
            this.getError(e);
            this.getting = false;
          })
      }
    },
    set_model() {},
    upd(){},
    then_get_rows(r) { return r },
  },
};
</script>
